{
  "bulkOnboarding": {
    "departments": {
      "title": "Abteilungen anlegen",
      "description": "Lade eine Excel-Datei mit der Abteilungsstruktur deiner Organisation hoch. Abteilungen werden vorübergehend gespeichert, bis Manager in den nächsten Schritten zugewiesen werden.",
      "uploadTitle": "Abteilungen aus Excel hochladen",
      "toast": {
        "createSuccess": "Abteilungen erfolgreich erstellt!",
        "createFailed": "Übermittlung fehlgeschlagen. Bitte versuche es erneut.",
        "validationRequired": "Bitte lade mindestens eine Abteilung hoch",
        "fixErrors": "Bitte behebe alle Validierungsfehler, bevor du fortfährst"
      }
    },
    "users": {
      "title": "Mitarbeiter anlegen",
      "description": "Lade eine Excel-Datei mit den Mitarbeitern deiner Organisation hoch. Wenn Mitarbeiter erstellt werden, werden Abteilungen mit passenden Manager-E-Mails automatisch zugewiesen. Alle verbleibenden Abteilungen müssen im nächsten Schritt manuell aufgelöst werden.",
      "uploadTitle": "Mitarbeiter aus Excel hochladen",
      "toast": {
        "createSuccess": "Mitarbeiter erfolgreich erstellt! Abteilungen mit passenden Manager-E-Mails wurden automatisch zugewiesen.",
        "createFailed": "Übermittlung fehlgeschlagen. Bitte versuche es erneut.",
        "validationRequired": "Bitte lade mindestens einen Mitarbeiter hoch",
        "fixErrors": "Bitte behebe alle Validierungsfehler, bevor du fortfährst"
      }
    },
    "processes": {
      "uploadTitle": "Prozesse von Excel hochladen",
      "toast": {
        "createSuccess": "Prozesse erfolgreich erstellt! Prozessverantwortliche wurden automatisch basierend auf den Abteilungsmanagern zugewiesen.",
        "createFailed": "Prozesse konnten nicht erstellt werden",
        "fixErrors": "Bitte behebe Validierungsfehler, bevor du fortfährst"
      }
    },
    "resolution": {
      "description": "In einigen Fällen können wir die Manager-E-Mail nicht eindeutig mit einem Mitarbeiter verknüpfen. Prüfe deine Ergebnisse.",
      "loading": "Temporäre Abteilungen werden geladen...",
      "success": {
        "title": "Alle Abteilungen zugewiesen!",
        "description": "Alle Abteilungen wurden erfolgreich Managern zugewiesen. Du kannst nun mit der Einrichtung fortfahren."
      },
      "instructions": "Weise jeder Abteilung einen Manager aus deiner Benutzerliste zu. Nach der Zuweisung wird die Abteilung in eine permanente Abteilung umgewandelt.",
      "table": {
        "name": "Name",
        "abbreviation": "Abkürzung",
        "managerEmail": "Gesuchte E-Mail",
        "managerFound": "Manager gefunden und bereit zur Auflösung",
        "alreadyResolved": "Bereits aufgelöst",
        "noDescription": "Keine Beschreibung",
        "assignManager": "Zugewiesener Manager"
      },
      "toast": {
        "batchSuccess": "{{count}} Abteilung(en) erfolgreich aufgelöst",
        "partialSuccess": "{{success}} Abteilung(en) aufgelöst. {{failed}} fehlgeschlagen.",
        "batchFailed": "Abteilungen konnten nicht aufgelöst werden",
        "unresolvedDepartments": "Bitte löse alle Abteilungen auf, bevor du die Einrichtung abschließt. Jeder Abteilung muss ein Manager zugewiesen werden."
      }
    },
    "assignManager": {
      "selectPlaceholder": "Mitarbeiter wählen…"
    },
    "validation": {
      "nameRequired": "Name ist erforderlich",
      "abbreviationRequired": "Abkürzung ist erforderlich",
      "descriptionRequired": "Beschreibung ist erforderlich",
      "invalidEmail": "Ungültige E-Mail-Adresse",
      "firstNameRequired": "Vorname ist erforderlich",
      "lastNameRequired": "Nachname ist erforderlich",
      "departmentRequired": "Abteilung ist erforderlich",
      "roleRequired": "Stelle ist erforderlich",
      "ownerEmailInvalid": "Gültige E-Mail-Adresse erforderlich",
      "orgFunctionNameRequired": "Funktion / Team ist erforderlich",
      "licenceSeatsInvalid": "Lizenzplätze müssen eine ganze Zahl größer oder gleich 0 sein",
      "unknownMemberEmail": "{{email}} gehört zu keinem Mitarbeiter",
      "duplicateEntry": "Doppelter Eintrag",
      "circularParent": "Eine Abteilung kann nicht sich selbst übergeordnet sein – auch nicht über Zwischenebenen",
      "existingMember": "Bereits vorhanden – dieses Mitglied existiert schon und kann hier nicht bearbeitet werden",
      "roleDescriptionConflict": "Gleiche Stelle, unterschiedliche Beschreibungen – eine Stelle hat genau eine Stellenbeschreibung",
      "accountableEmailInvalid": "keine gültige E-Mail-Adresse",
      "accountableEmailNotFound": "die E-Mail-Adresse {{email}} gehört zu keinem Mitglied"
    },
    "excel": {
      "sheets": {
        "instructions": "Anleitung",
        "departments": "Abteilungen",
        "users": "Mitarbeiter",
        "processes": "Prozesse",
        "functions": "Funktionen",
        "teams": "Teams",
        "memberships": "Mitgliedschaften",
        "systems": "Systeme",
        "dataSyncPeople": "Mitarbeiter"
      },
      "columns": {
        "departments": {
          "name": "Name*",
          "abbreviation": "Abkürzung*",
          "description": "Beschreibung",
          "parentAbbreviation": "Übergeordnete Abteilung",
          "managerEmail": "Manager-E-Mail"
        },
        "users": {
          "firstName": "Vorname*",
          "lastName": "Nachname*",
          "email": "E-Mail*",
          "department": "Abteilung*",
          "role": "Stelle*",
          "roleDescription": "Stellenbeschreibung"
        },
        "processes": {
          "name": "Name*",
          "description": "Beschreibung*",
          "department": "Abteilung*",
          "ownerEmail": "Prozessverantwortlicher (E-Mail)*",
          "accountableEmail": "Rechenschaftspflichtig (E-Mail, optional)"
        },
        "functions": {
          "name": "Name*",
          "description": "Beschreibung",
          "department": "Abteilung",
          "leadEmail": "Leitung (E-Mail)",
          "email": "Geteiltes Postfach (E-Mail)"
        },
        "teams": {
          "name": "Name*",
          "description": "Beschreibung",
          "department": "Abteilung",
          "leadEmail": "Leitung (E-Mail)",
          "email": "Geteiltes Postfach (E-Mail)"
        },
        "memberships": {
          "orgFunctionName": "Funktion / Team*",
          "memberEmail": "Mitglied (E-Mail)*"
        },
        "systems": {
          "name": "Name*",
          "description": "Beschreibung",
          "category": "Kategorie",
          "url": "URL",
          "licenceSeats": "Lizenzplätze",
          "ownerEmail": "Systemverantwortlicher (E-Mail)*"
        },
        "dataSync": {
          "id": "ID",
          "parentDepartment": "Übergeordnete Abteilung",
          "lead": "Leitung (E-Mail)",
          "owner": "Systemverantwortlicher (E-Mail)",
          "location": "Standort"
        }
      }
    }
  },
  "welcomePage": {
    "welcome": "Willkommen",
    "checkTask": "Überprüfe deine Aufgaben",
    "minimizeVolume": "Minimaler Aufwand für dich, Maximaler Vorteil für Alle",
    "minimizeVolumeDesc": "Erfasse und optimiere Prozesse mit minimalem Aufwand und maximaler Effizienz.",
    "allResourceInOne": "Alle Prozessressourcen an einem Ort",
    "allResourceInOneDesc": "Verwalte alle prozessrelevanten Ressourcen zentral und effizient.",
    "completeProcess": "Komplette Prozessübersicht - Einfach nachvollziehbar",
    "completeProcessDesc": "Behalte den Überblick über alle Prozesse mit unserer intuitiven BPMN-Darstellung.",
    "howRecordingWork": "Wie funktioniert virale Prozessaufnahme?",
    "continueToDashboard": "Weiter zum Dashboard"
  },
  "initialSetup": {
    "title": "Ersteinrichtung",
    "wizardHeading": "BLIKS IO Einrichtungswizard",
    "topBar": {
      "logoAlt": "BLIKS IO Logo"
    },
    "pending": {
      "title": "Ersteinrichtung noch nicht abgeschlossen",
      "description": "Deine Organisation wurde noch nicht vollständig eingerichtet. Ein Organisationsmanager deiner Organisation muss zuerst die Ersteinrichtung abschließen – sobald das erledigt ist, kannst du direkt loslegen. Diese Seite aktualisiert sich automatisch."
    },
    "removalBlocked": {
      "department": {
        "processes": "Die Abteilung kann nicht gelöscht werden: {{count}} Prozesse verweisen darauf. Weise die Prozesse im Schritt „Prozesse“ zuerst einer anderen Abteilung zu."
      },
      "user": {
        "systems": "Der Mitarbeiter kann nicht gelöscht werden: {{count}} Systeme haben ihn als Verantwortlichen. Weise die Systeme im Schritt „Systeme“ zuerst einer anderen Person zu.",
        "processes": "Der Mitarbeiter kann nicht gelöscht werden: {{count}} Prozesse haben ihn als Verantwortlichen oder Ersteller. Weise die Prozesse im Schritt „Prozesse“ zuerst einer anderen Person zu."
      },
      "orgFunction": {
        "mainRole": "Die Funktion kann nicht gelöscht werden: Sie ist die Hauptfunktion von {{count}} Mitarbeitern. Ändere zuerst deren Stelle im Schritt „Mitarbeiter“."
      }
    },
    "completeBlocked": {
      "title": "Die Ersteinrichtung kann noch nicht abgeschlossen werden:",
      "unresolvedDepartments": "{{count}} Abteilungen haben keine zugeordnete Leitung.",
      "goToResolve": "Leitungen zuordnen",
      "usersWithoutDepartment": "{{count}} Mitarbeiter haben keine Abteilung.",
      "goToUsers": "Zum Schritt Mitarbeiter"
    },
    "steps": {
      "welcome": "Willkommen",
      "departments": "Abteilungen",
      "employees": "Mitarbeiter",
      "resolveManagers": "Manager auflösen",
      "functions": "Funktionen",
      "teams": "Teams",
      "systems": "Systeme",
      "processes": "Prozesse",
      "overview": "Überblick & Abschluss"
    },
    "stepDescriptions": {
      "departments": "Das Gerüst Deiner Organisation",
      "employees": "Personen, je einer Stelle zugeordnet",
      "resolveManagers": "Manager werden aus den hinzugefügten Mitarbeitern verknüpft",
      "functions": "Zusätzliche Funktionen von Mitarbeitern",
      "teams": "Teams, in denen Mitarbeiter zusammenarbeiten",
      "systems": "Die eingesetzten Software-Systeme",
      "processes": "Liste fürs spätere virale Erfassen",
      "overview": "Organigramm-Vorschau & Bestätigung"
    },
    "footer": {
      "next": "Weiter",
      "skip": "Überspringen",
      "finish": "Abschließen",
      "start": "Los geht's"
    },
    "autosave": {
      "pending": "Ungespeicherte Änderungen",
      "saving": "Speichert…",
      "saved": "Automatisch gespeichert",
      "error": "Automatisches Speichern fehlgeschlagen — Weiter versucht es erneut"
    },
    "welcome": {
      "title": "Herzlich willkommen in BLIKS IO",
      "intro": "Bevor BLIKS IO in deiner Organisation ausgerollt wird, bauen wir gemeinsam in wenigen Schritten ein vollständiges Abbild deiner Organisation auf. Keine Sorge: Während der Einrichtung erhält niemand eine Benachrichtigung — auch die Personen nicht, die du hier anlegst.",
      "checklist": {
        "title": "Was du bereithalten solltest",
        "departments": "Deine Organisationsabteilungen und deren Hierarchie",
        "people": "Alle Personen deiner Organisation",
        "systems": "Die Systeme, die im Einsatz sind",
        "processes": "Die Prozesse, die du später erfassen möchtest"
      },
      "pauseResume": "Diese Informationen liegen meist zentral in eurer HCM- und EAM-Software. Fehlt etwas? Kein Problem — du kannst jederzeit pausieren und genau dort weitermachen, wo du aufgehört hast."
    },
    "outcomes": {
      "title": "Das erhältst du am Ende",
      "description": "Nach der Ersteinrichtung ist BLIKS IO bereit, flächendeckend in deiner Organisation eingesetzt zu werden. Aus den vier Bausteinen entstehen drei klare Ergebnisse.",
      "cards": {
        "structure": {
          "title": "Aufbaustruktur",
          "body": "Abteilungen, Stellen und Teams & Zusatzfunktionen. Das Organigramm entsteht automatisch aus den Beziehungen."
        },
        "systems": {
          "title": "Systemübersicht",
          "body": "Alle Systeme, die in deiner Organisation im Einsatz sind — inklusive Katalog-Metadaten."
        },
        "processes": {
          "title": "Prozessübersicht",
          "body": "Die Prozesse, die du erfassen möchtest — wie sie wirklich laufen, hält BLIKS IO später über die virale Aufnahme fest."
        }
      },
      "hint": "<bold>Zwei Dinge vorab:</bold> Es ist nicht schlimm, wenn im Ersteinrichter noch nicht alles vollständig ist — du kannst später jederzeit manuell nachbessern. Und möchtest du deine Organisation automatisch aufbauen und aktuell halten? Sprich uns an: wir verbinden BLIKS IO direkt mit eurer HCM- und EAM-Software."
    },
    "doneNotice": {
      "departments": {
        "title": "Abteilungen sind bereits eingerichtet",
        "description": "Der Import wurde abgeschlossen. Änderungen an bestehenden Zeilen und neue Zeilen speichert <bold>Weiter</bold> direkt. Entfernst du eine Zeile, wird der importierte Eintrag gelöscht und Verweise darauf werden geleert – entstandene Lücken müssen vor dem Abschließen behoben werden. Auch die Manager-Zuordnung einer Abteilung änderst du hier über die Spalte Manager-E-Mail."
      },
      "users": {
        "title": "Mitarbeiter sind bereits eingerichtet",
        "description": "Der Import wurde abgeschlossen. Änderungen an bestehenden Zeilen und neue Zeilen speichert <bold>Weiter</bold> direkt. Entfernst du eine Zeile, wird der importierte Eintrag gelöscht und Verweise darauf werden geleert – entstandene Lücken müssen vor dem Abschließen behoben werden."
      },
      "optional": {
        "title": "Dieser Schritt wurde bereits durchlaufen",
        "description": "Du kannst jederzeit weitere Einträge ergänzen – bestehende bleiben unverändert."
      }
    },
    "resolve": {
      "counters": {
        "open": "Offen",
        "resolved": "Bereits gelöst"
      },
      "suggestion": "Vorschlag: {{name}}",
      "applySuggestion": "Übernehmen"
    },
    "functionsTeams": {
      "autoCreatedBanner": "{{count}} Funktionen wurden bereits aus den Stellenbezeichnungen deiner Mitarbeiter angelegt.",
      "functionsSection": {
        "title": "Funktionen",
        "stepTitle": "Funktionen anlegen",
        "description": "Häufig agieren Mitarbeiter nicht als Person, sondern in ihrer Funktion — z.B. „Datenschutzbeauftragte“ oder „Product Owner“. Lege sie hier an oder lade sie per Excel hoch.",
        "hint": "Wenn dir die Daten gerade nicht vorliegen, kannst du diesen Schritt überspringen — Funktionen lassen sich jederzeit ergänzen."
      },
      "teamsSection": {
        "title": "Teams",
        "stepTitle": "Teams anlegen",
        "description": "Gruppen, die zusammenarbeiten — z.B. „First Level Support Team“. Lege Teams an und ordne ihnen anschließend Mitglieder zu.",
        "hint": "Optional — Teams lassen sich jederzeit ergänzen, auch während der Prozessaufnahme."
      },
      "columns": {
        "lead": "Leitung",
        "sharedMailbox": "Shared-Postfach",
        "member": "Mitarbeiter",
        "function": "Funktion",
        "team": "Team"
      },
      "membershipsTable": {
        "heading": "Mitgliedschaften"
      },
      "mailImportNote": "Beim Excel-Import wird die Leitung über die E-Mail einer Person zugeordnet. Nicht gefundene E-Mails werden rot markiert und müssen manuell einer Person zugewiesen werden. Teams legst du im nächsten Schritt an.",
      "toast": {
        "fixErrors": "Bitte behebe zuerst die Fehler in den hochgeladenen Zeilen",
        "createSuccess": "{{created}} Einträge angelegt, {{linked}} Mitgliedschaften verknüpft",
        "createFailed": "Der Import ist fehlgeschlagen"
      },
      "mainRoleLockedRemove": "Diese Funktion ist als Stelle zugewiesen und kann daher nicht gelöscht werden – ändere zuerst die Stelle der betroffenen Personen."
    },
    "systems": {
      "title": "Systeme erfassen",
      "description": "Welche Software nutzt deine Organisation? Erfasse jedes System mit den wichtigsten Angaben — oder lade eine bestehende Systemliste per Excel hoch.",
      "toast": {
        "fixErrors": "Bitte behebe zuerst die Fehler in den hochgeladenen Zeilen",
        "createSuccess": "Systeme gespeichert",
        "createFailed": "Systeme konnten nicht angelegt werden"
      }
    },
    "processes": {
      "title": "Prozesse erfassen",
      "description": "Welche Prozesse soll BLIKS IO aufnehmen? Erfasse hier nur die Topline-Liste — die Details liefern später die Mitarbeitenden selbst.",
      "hint": "Du kannst jederzeit weitere Prozesse ergänzen — oder diesen Schritt ganz überspringen.",
      "mailImportNote": "Verantwortliche werden über eine Person zugewiesen. Beim Excel-Import erfolgt die Zuordnung über die E-Mail — nicht gefundene E-Mails werden rot als „Benutzer nicht gefunden“ markiert.",
      "ownerEmail": "Prozessverantwortlicher (E-Mail)"
    },
    "columns": {
      "systems": {
        "name": "Systemname",
        "licenceSeats": "Lizenzen",
        "owner": "Verantwortlich"
      },
      "processes": {
        "owner": "Prozessverantwortlich",
        "accountable": "Rechenschaftspflichtig"
      }
    },
    "columnHints": {
      "departments": {
        "name": "Vollständiger Name der Abteilung",
        "abbreviation": "Kurz & eindeutig, z. B. \"FC\"",
        "description": "Wofür ist die Abteilung zuständig?",
        "parentAbbr": "Leer = oberste Ebene",
        "managerEmail": "E-Mail der leitenden Person"
      },
      "users": {
        "firstName": "z. B. \"Patrick\"",
        "lastName": "z. B. \"Lenz\"",
        "email": "Geschäftlich, muss eindeutig sein",
        "department": "Abteilung, in der die Person arbeitet",
        "role": "Die Stelle, z. B. \"Head of Controlling\"",
        "roleDescription": "Aufgaben & Schwerpunkte der Stelle"
      },
      "functions": {
        "name": "z. B. \"Datenschutzbeauftragte\"",
        "description": "Aufgaben & Verantwortlichkeiten",
        "department": "Leer, wenn cross-funktional",
        "lead": "E-Mail der Leitung",
        "sharedMailbox": "Geteiltes Postfach, z. B. support@…"
      },
      "memberships": {
        "member": "Person, die die Funktion ausübt",
        "target": "Funktion oder Team der Person"
      },
      "systems": {
        "name": "Name des Systems oder Anbieters",
        "category": "z. B. CRM, ERP, HR-Tool",
        "url": "Website des Anbieters",
        "licenceSeats": "Verfügbare Lizenzen, falls begrenzt",
        "owner": "Verantwortliche Person für das System"
      },
      "processes": {
        "name": "z. B. \"Neukundenanlage\"",
        "description": "Was leistet der Prozess? Anfang & Ende",
        "department": "Abteilung, zu der der Prozess gehört",
        "owner": "Verantwortlich für die Dokumentationspflege",
        "accountable": "Optional — standardmäßig der Abteilungsleiter"
      }
    },
    "fieldExplainer": {
      "required": "Pflicht",
      "optional": "Optional",
      "headings": {
        "departments": "Diese Informationen brauchen wir je Abteilung",
        "users": "Diese Informationen brauchen wir je Person",
        "functionsTeams": "Diese Informationen brauchen wir – aufgeteilt in zwei Bereiche",
        "systems": "Diese Informationen brauchen wir je System",
        "processes": "Diese Informationen brauchen wir je Prozess"
      },
      "sections": {
        "entity": "1. Funktion oder Team",
        "memberships": "2. Mitgliedschaften"
      },
      "fields": {
        "departments": {
          "name": "Vollständiger Name der Abteilung, z. B. \"Controlling & Reporting\"",
          "abbreviation": "Kurzes, eindeutiges Kürzel, z. B. \"FC\". Dient als Anker, um Abteilungen zu verknüpfen.",
          "description": "Wofür ist die Abteilung zuständig? z. B. \"Planung, Budgetierung, Reporting\". Die Präzision der Beschreibung kann Einfluss auf KI-basierte Analyseergebnisse nehmen. Du kannst die Beschreibung jederzeit im Nachgang erweitern.",
          "parentAbbr": "Die Abkürzung der übergeordneten Abteilung – nur leer lassen für die oberste Ebene. Hieraus entsteht automatisch Dein Organigramm.",
          "managerEmail": "E-Mail der Person, die die Abteilung leitet. Wird in Schritt 2 automatisch verknüpft, sobald die Person als Mitarbeiter existiert."
        },
        "users": {
          "firstName": "Vorname der Person, z. B. \"Patrick\"",
          "lastName": "Nachname der Person, z. B. \"Lenz\"",
          "email": "Geschäftliche E-Mail-Adresse der Person. Muss eindeutig sein. Wird mit Manager-E-Mails aus Schritt 1 abgeglichen und automatisch verknüpft.",
          "department": "Die Abkürzung der Abteilung, in der die Person arbeitet – aus der Liste in Schritt 1. Verortet die Person und die Stelle im Organigramm.",
          "role": "Wofür ist die Person eingestellt? z. B. \"Head of Controlling\", \"Sachbearbeiter Buchhaltung\". Das ist die Stelle.",
          "roleDescription": "Wofür ist diese Stelle verantwortlich? Aufgaben, Verantwortlichkeiten, Schwerpunkte. Grundlage für spätere Analysen – je präziser, desto besser die Ergebnisse."
        },
        "functions": {
          "name": "Eindeutiger Name der Funktion, z. B. \"Datenschutzbeauftragte\", oder des Teams, z. B. \"First Level Support Team\"",
          "description": "Aufgaben und Verantwortlichkeiten. Grundlage für spätere Analysen.",
          "department": "Cross-funktionale Funktionen wie \"Productowner\" leer lassen. Nur ausfüllen, wenn Funktionen oder Teams klar einer Abteilung zugewiesen sind.",
          "lead": "E-Mail der Person, die die Funktion oder das Team leitet. Häufig haben nur Teams (z. B. \"First Level Support Team\") eine Leitung.",
          "sharedMailbox": "Gemeinsames geteiltes Postfach der Funktion oder des Teams, z. B. \"support@…\""
        },
        "memberships": {
          "member": "E-Mail einer Person aus Schritt 2. Eine Person kann in beliebig vielen Funktionen und Teams tätig sein.",
          "target": "Name der Funktion oder des Teams aus dem Bereich oben. Verknüpft Personen mit Funktionen."
        },
        "systems": {
          "name": "Wie heißt das System oder der Anbieter des Systems? Wenn Du das System in Deiner Organisation unter einem speziellen Namen kennst, nutze gerne euer unternehmensinternes Vokabular.",
          "description": "Beschreibe die Fähigkeiten des Systems. Für was wird es bei euch eingesetzt?",
          "category": "Um welche Art von System handelt es sich? z. B. \"CRM\", \"ERP\", \"HR-Tool\"",
          "url": "Unter welcher URL ist der Anbieter des Systems aufzufinden?",
          "licenceSeats": "Für einige eurer Systeme habt ihr nur eine gewisse Anzahl an freien Lizenzen. Sofern ein Limit besteht, kannst Du die Anzahl hier mit vermerken. Wir analysieren, wie weit ihr in eurem operativen Alltag die Lizenzplätze ausreizt.",
          "owner": "E-Mail der Person, die in Deinem Unternehmen für das System verantwortlich ist und am besten beschreiben kann, was in dem System auf welchem Wege passiert."
        },
        "processes": {
          "name": "Klare Bezeichnung, z. B. \"Neukundenanlage\", \"Vertriebsprozess\" o. ä.",
          "description": "Was leistet dieser Prozess? Womit beginnt er, womit endet er? Diese Beschreibung ist die Grundlage für spätere Analysen und für die Aufnahme durch die Mitarbeitenden – je präziser, desto besser.",
          "department": "Kürzel der Abteilung aus Schritt 1, zu der der Prozess gehört.",
          "owner": "E-Mail der Person, die diesen Prozess in BLIKS IO verantwortet. Wichtig: Gemeint ist nur die Verantwortung dafür, dass der Prozess in BLIKS IO dokumentiert und aktuell gehalten wird – nicht die inhaltliche oder ergebnisverantwortliche Rolle im Unternehmen. Ist diese Rolle bei euch nicht klar definiert, wähle die Person, bei der die Dokumentationspflege am besten aufgehoben ist.",
          "accountable": "E-Mail der Person, die für diesen Prozess rechenschaftspflichtig ist (im RACI-Sinn). Optional: Bleibt das Feld leer, wird der aktuelle Abteilungsleiter als rechenschaftspflichtig angezeigt — spätere Wechsel der Abteilungsleitung werden dann automatisch übernommen."
        }
      }
    },
    "overview": {
      "title": "Herzlichen Glückwunsch",
      "subtitle": "Deine Organisation ist nun in BLIKS IO erfasst.",
      "description": "Du hast das Skelett aufgesetzt. Den Rest — wer wirklich was tut, wie Prozesse tatsächlich laufen, welche Schatten-Systeme im Einsatz sind — fügen die Mitarbeiter während der Aufnahme ab jetzt automatisch hinzu.",
      "cards": {
        "departments": "Abteilungen",
        "members": "Mitarbeiter & Stellen",
        "functions": "Funktionen",
        "teams": "Teams",
        "systems": "Systeme",
        "processes": "Prozesse",
        "departmentLevels": "in {{count}} Ebenen",
        "distinctPositions": "{{count}} Stellenbezeichnungen",
        "fromPositions": "davon {{count}} aus Stellen",
        "readyForRecording": "bereit für Aufnahme"
      },
      "organigram": {
        "title": "Dein Organigramm",
        "description": "Automatisch gebaut aus den Abteilungs-Beziehungen.",
        "fullscreen": "Vollbild ansehen"
      },
      "toast": {
        "completed": "Ersteinrichtung abgeschlossen!",
        "completeFailed": "Abschluss fehlgeschlagen",
        "pendingChanges": "Es gibt noch nicht übernommene Änderungen. Bitte bestätige den betroffenen Schritt mit „Weiter“, bevor du die Einrichtung abschließt."
      },
      "invite": {
        "checkboxLabel": "Allen {{count}} Mitgliedern jetzt eine Einladung senden",
        "helper": "Mitglieder erhalten eine E-Mail, um ihr Konto zu aktivieren und ein Passwort zu vergeben.",
        "success": "{{count}} Einladungen gesendet",
        "skipped": "{{count}} Mitglieder übersprungen"
      }
    },
    "upload": {
      "errorBanner": "Bitte behebe die in der Tabelle markierten Fehler.",
      "invalidRowsCount": "{{count}} Zeile(n) mit Validierungsfehlern"
    },
    "uploadFromExcel": "Excel importieren",
    "personio": {
      "load": "Aus Personio laden",
      "loaded": "Aus Personio geladen.",
      "unlinkDescription": "Die Zugangsdaten werden gelöscht; geladene Zeilen bleiben."
    },
    "tables": {
      "departments": "Abteilungen",
      "users": "Mitarbeiter",
      "systems": "Systeme",
      "processes": "Prozesse"
    },
    "draftTable": {
      "removeRow": "Zeile entfernen",
      "noSelection": "– keine Auswahl –",
      "userNotFound": "Benutzer nicht gefunden"
    },
    "existingEntities": {
      "title": "Bereits vorhanden ({{count}})",
      "editableNote": "Diese Mitglieder existieren bereits – Name und E-Mail sind gesperrt. Weise ihnen hier Abteilung und Stelle zu."
    },
    "protectedRows": {
      "lockedIdentity": "Name und E-Mail dieses Mitglieds werden vom bestehenden Konto verwaltet und können hier nicht geändert werden.",
      "placementFailed": "Die Abteilungszuordnung für bestehende Mitglieder konnte nicht gespeichert werden."
    },
    "addRow": {
      "department": "Abteilung hinzufügen",
      "employee": "Mitarbeiter hinzufügen",
      "orgFunction": "Funktion hinzufügen",
      "team": "Team hinzufügen",
      "membership": "Mitgliedschaft hinzufügen",
      "system": "System hinzufügen",
      "process": "Prozess hinzufügen"
    },
    "clearDrafts": "Liste leeren",
    "clearConfirm": {
      "title": "Liste leeren?",
      "description": "Alle Zeilen in der Tabelle werden entfernt. Das kann nicht rückgängig gemacht werden.",
      "deleteAllDescription": "Alle Zeilen werden entfernt. Bereits importierte Einträge werden beim Fortfahren endgültig gelöscht.",
      "confirm": "Leeren"
    },
    "pendingDeleteAll": "Die Liste wurde geleert: Alle importierten Einträge werden mit „Weiter“ endgültig gelöscht.",
    "doneBadge": "Abgeschlossen",
    "usersImport": {
      "membersNotLoaded": "Mitgliederliste konnte noch nicht geladen werden – bitte erneut versuchen."
    }
  }
}
